import React from "react";
import BreadCrumbs from "@surgia/ui/components/breadCrumb";
import Button from "@surgia/ui/components/button";
import { useNavigate } from "react-router-dom";

interface ProductNotFoundProps {
  productName?: string;
}

const ProductNotFound: React.FC<ProductNotFoundProps> = ({ productName }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-start p-0 relative w-full min-h-screen bg-white">
      {/* Page Header */}
      <div className="flex flex-col items-start p-0 gap-4 w-full h-[121px] flex-none order-0 self-stretch flex-grow-0 z-0">
        {/* Breadcrumb */}
        <div className="w-full px-4 sm:px-6 pt-6">
          <BreadCrumbs
            items={[
              { label: "Tenants" },
              {
                label: "Tenant details",
              },
              {
                label: "Edit product",
              },
            ]}
          />
        </div>

        {/* Header Content */}
      </div>

      {/* Main Content - Error State */}
      <div className="flex w-full flex-1 justify-center p-4 sm:p-6 pt-16 sm:pt-24">
        <div className="text-center max-w-md mx-auto">
          {/* Error Message */}
          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            Product Not Found
          </h2>

          <p className="text-gray-600 mb-6 leading-relaxed">
            {productName
              ? `The product "${productName}" could not be found. It may have been removed or you may not have permission to access it.`
              : "The requested product could not be found. It may have been removed."}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate("/tenants")}
              className="w-full sm:w-auto"
            >
              Return to Tenants
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductNotFound;
